import Commons from '../../../../Services/Common/Common';
import dayjs from 'dayjs';

/**
 * PPE_BASIC_02 (보호구 관리대장) 스키마
 * 서버 응답: PascalCase (ErCd, EquipNm, Spec, Price, Unit, PaymentStandard, ManagerDepartment, DepNmLast, ManagerId, ManagerName, MoveDate, MovementId, InQty, OutQty, SignedQty, CurrentQty, Reason, CreateId, CreateDate)
 * 그리드 데이터: camelCase로 저장
 * 저장 시 서버 요청: PascalCase (서버가 기대하는 형식)
 */
export const PPE_BASIC_02_Schema = {
  fields: {
    // 그리드 데이터: camelCase로 저장
    erCd: { initial: '', label: '보호구코드' },
    equipNm: { initial: '', label: '보호구명' },
    spec: { initial: '', label: '규격' },
    price: { initial: 0, label: '단가' },
    unit: { initial: '', label: '단위' },
    paymentStandard: { initial: '', label: '지급기준' },
    managerDepartment: { initial: '', label: '관리부서코드' },
    depNmLast: { initial: '', label: '부서명' },
    managerId: { initial: '', label: '담당자ID' },
    managerName: { initial: '', label: '담당자명' },
    moveDate: { initial: null, label: '이동일자' },
    movementId: { initial: '', label: '이동ID' },
    inQty: { initial: 0, label: '입고수량' },
    outQty: { initial: 0, label: '출고수량' },
    signedQty: { initial: 0, label: '부호있는수량' },
    currentQty: { initial: 0, label: '현재재고수량' },
    reason: { initial: '', label: '사유' },
    createId: { initial: '', label: '생성ID' },
    createDate: { initial: null, label: '생성일자' },
  },

  mapper: {
    // 보호구 관리대장 조회
    search1: {
      YearMonth: (_, context) => {
        // 'YYYY-MM' 형식으로 전달 (예: '2026-01')
        const year = context.search?.currentYear || dayjs().format('YYYY');
        const month = context.search?.currentMonth || dayjs().format('MM');
        const yearMonth = `${year}-${month}`;
        return Commons.EncryptAES(yearMonth) || '';
      },
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
    },

    // 보호구 관리대장 저장 (재고 이동)
    save1: {
      ErCd: (row) => Commons.EncryptAES(row.erCd || '') || '',
      MovementType: (row) => {
        // gubun이 '입고'면 "0", '출고'면 "1"
        const gubun = row.gubun || '';
        const movementType = gubun === '입고' ? '0' : '1';
        return Commons.EncryptAES(movementType) || '';
      },
      MoveQty: (row) => {
        // gubun이 '입고'면 inQty, '출고'면 outQty
        const gubun = row.gubun || '';
        let qty = gubun === '입고' ? row.inQty : row.outQty;
        
        // 빈 값, null, undefined, 빈 문자열 처리
        if (qty === null || qty === undefined || qty === '' || qty === '0') {
          qty = 0;
        }
        
        // 숫자로 변환
        qty = Number(qty);
        
        // NaN이면 0으로 처리
        if (isNaN(qty)) {
          qty = 0;
        }
        
        return Commons.EncryptAES(String(qty)) || '';
      },
      Reason: (row) => Commons.EncryptAES(row.reason || '') || '',
      MoveDate: (row) => {
        // moveDate 또는 inDate/outDate 사용
        const date = row.moveDate || row.inDate || row.outDate;
        if (!date) return '';
        const dateStr = dayjs(date).format('YYYY-MM-DD');
        return Commons.EncryptAES(dateStr) || '';
      },
      UserId: (_, context) =>
        Commons.EncryptAES(context.userInfo?.userid || '') || '',
    },
  },
};
